<div class="layout-content">

  <div class="grid align-items-stretch">
    <ng-container *ngFor="let config of widgetConfigs$ | async">
      <selfai-platform-home-page-base-widget
        class="block col md:col-4"
        [config]="config"
      ></selfai-platform-home-page-base-widget>
    </ng-container>
  </div>
</div>
